/* MxL Stylist Pull portal.
   - Access: server-granted (customer tag via data-auth) or SHA-256-checked
     access code (hash in markup, never the code). Session in sessionStorage
     with expiry. No secrets in this file.
   - Pull list in localStorage (product selections only). Form drafts in
     sessionStorage, cleared on submit.
   - Submission: one Klaviyo client event (public company ID) with a unique_id
     equal to the request reference, so retries can never double-send.
   - Availability = SAMPLE inventory only: every variant in card JSON is a
     sample size (mxl.sample_qty > 0 at render time) and carries sampleQty,
     which caps the requestable quantity. Retail inventory is never read.
   - Never touches the retail cart, checkout, inventory, or Back in Stock. */
(function () {
  var root = document.getElementById("MxlSp");
  if (!root) return;

  var CFG = {
    hash: root.dataset.codeHash || "",
    company: root.dataset.companyId,
    sessionMs: (parseInt(root.dataset.sessionHours || "12", 10)) * 3600 * 1000,
    maxQty: parseInt(root.dataset.maxQty || "10", 10),
    maxItems: parseInt(root.dataset.maxItems || "40", 10),
  };

  /* ---------- For Pull Only catalog ------------------------------------
     For Pull Only pieces are ordinary ACTIVE, Online-Store-published products
     carrying the 'for pull only' tag, so the section's normal collection loop
     renders them server-side exactly like every other card — Shopify is the
     only runtime source of truth and nothing has to be generated or synced.
     They are kept off every public retail surface by the storefront guards in
     product-card / collection / search / predictive-search / recommendations.
     All this needs to do is reveal the tab when such cards actually exist. */
  var hasPullOnly = root.querySelector('[data-sp-card][data-pullonly="1"]') !== null;
  (function () {
    var tab = root.querySelector("[data-sp-pullonly-tab]");
    if (tab && hasPullOnly) tab.hidden = false;
  })();

  /* "August 5, 2026 at 2:45 AM" in showroom (New York) time, DST included. */
  function nyStamp(d) {
    var p = {};
    new Intl.DateTimeFormat("en-US", {
      timeZone: "America/New_York", month: "long", day: "numeric", year: "numeric",
      hour: "numeric", minute: "2-digit", hour12: true
    }).formatToParts(d || new Date()).forEach(function (x) { p[x.type] = x.value; });
    return p.month + " " + p.day + ", " + p.year + " at " +
           p.hour + ":" + p.minute + " " + (p.dayPeriod || "").toUpperCase();
  }

  var VIEWS = ["gate", "browse", "pull", "form", "review", "done"];
  var els = {
    portal: root.querySelector("[data-sp-portal]"),
    gate: root.querySelector('[data-sp-view="gate"]'),
    gateForm: root.querySelector(".mxl-sp-gate-form"),
    gateErr: root.querySelector(".mxl-sp-gate-error"),
    gateExp: root.querySelector(".mxl-sp-gate-expired"),
    count: root.querySelector("[data-sp-count]"),
    countLong: root.querySelector("[data-sp-count-long]"),
    pullList: root.querySelector("[data-sp-pull-list]"),
    pullEmpty: root.querySelector("[data-sp-pull-empty]"),
    form: root.querySelector("[data-sp-form]"),
    review: root.querySelector("[data-sp-review]"),
    status: root.querySelector("[data-sp-status]"),
    ref: root.querySelector("[data-sp-ref]"),
    time: root.querySelector("[data-sp-time]"),
    doneSummary: root.querySelector("[data-sp-done-summary]"),
  };

  /* ---------- session ---------- */
  function authed() {
    if (root.dataset.auth === "1") return true;
    try {
      var s = JSON.parse(sessionStorage.getItem("mxl_sp_session") || "null");
      if (s && s.exp > Date.now()) return true;
      if (s) { sessionStorage.removeItem("mxl_sp_session"); els.gateExp.hidden = false; }
    } catch (e) {}
    return false;
  }
  function grant() {
    sessionStorage.setItem("mxl_sp_session", JSON.stringify({ exp: Date.now() + CFG.sessionMs }));
  }
  function exit() {
    sessionStorage.removeItem("mxl_sp_session");
    location.hash = "";
    route();
  }
  function sha256hex(str) {
    return crypto.subtle.digest("SHA-256", new TextEncoder().encode(str)).then(function (buf) {
      return Array.from(new Uint8Array(buf)).map(function (b) { return b.toString(16).padStart(2, "0"); }).join("");
    });
  }

  /* ---------- pull list ---------- */
  function pull() { try { return JSON.parse(localStorage.getItem("mxl_sp_pull") || "[]"); } catch (e) { return []; } }
  function savePull(list) { localStorage.setItem("mxl_sp_pull", JSON.stringify(list)); refreshCount(); }
  function refreshCount() {
    var n = pull().reduce(function (a, i) { return a + i.qty; }, 0);
    if (els.count) {
      var prev = parseInt(els.count.textContent || "0", 10);
      els.count.textContent = n;
      if (n > prev) {
        els.count.classList.remove("mxl-sp-bump");
        void els.count.offsetWidth; /* restart the animation on rapid adds */
        els.count.classList.add("mxl-sp-bump");
      }
    }
    if (els.countLong) els.countLong.textContent = n + (n === 1 ? " item" : " items");
  }

  /* ---------- routing (hash-based so back/forward work) ---------- */
  function show(view) {
    root.querySelectorAll("[data-sp-view]").forEach(function (v) { v.hidden = v.dataset.spView !== view; });
    els.portal.hidden = view === "gate";
    els.gate.hidden = view !== "gate";
    var h = root.querySelector('[data-sp-view="' + view + '"] h1, [data-sp-view="' + view + '"] h2');
    /* Move focus to the view heading only on user-driven view changes.
       On initial page load nothing should be focused. */
    if (h) {
      h.setAttribute("tabindex", "-1");
      if (booted) h.focus({ preventScroll: false });
    }
  }
  function route() {
    var v = (location.hash || "#browse").slice(1);
    if (VIEWS.indexOf(v) < 0) v = "browse";
    if (!authed()) {
      /* open entrance (no access hash): an explicit view hash deep-links straight in */
      var raw = (location.hash || "").slice(1);
      if (!CFG.hash && raw && VIEWS.indexOf(raw) >= 0 && raw !== "gate") { grant(); }
      else { show("gate"); return; }
    }
    if ((v === "form" || v === "review") && pull().length === 0) v = "pull";
    if (v === "pull") renderPull();
    if (v === "review") renderReview();
    show(v);
  }
  window.addEventListener("hashchange", route);

  /* ---------- gate ---------- */
  els.gateForm.addEventListener("submit", function (e) {
    e.preventDefault();
    els.gateErr.hidden = true; els.gateExp.hidden = true;
    /* no hash configured = open entrance: Enter starts a session directly */
    if (!CFG.hash) { grant(); location.hash = "#browse"; route(); return; }
    var code = els.gateForm.querySelector("input").value.trim();
    sha256hex(code).then(function (hex) {
      if (hex === CFG.hash) { grant(); location.hash = "#browse"; route(); }
      else els.gateErr.hidden = false;
    });
  });
  root.querySelector("[data-sp-exit]").addEventListener("click", exit);

  /* ---------- browse: gender tabs + unified filter area + load more + add ---------- */
  /* Normalized filter model: primary gender tab (Womenswear default) AND
     collection (season) dropdown AND garment-category dropdown AND search —
     all criteria combine (AND), each also works alone, and Reset clears the
     three secondary filters. Every card carries data-gender, data-cats,
     data-seasons; swimwear is excluded at render time so it can never be
     browsed, searched, loaded, or added. Filters persist for the session so
     returning from the pull list keeps the view. */
  var FILT = "mxl_sp_filters";
  var activeGender = "womens", activeSeason = "", activeCat = "";
  try {
    var savedF = JSON.parse(sessionStorage.getItem(FILT) || "null");
    if (savedF) {
      activeGender = (savedF.g === "mens" || savedF.g === "pullonly") ? savedF.g : "womens";
      activeSeason = savedF.s || ""; activeCat = savedF.c || "";
    }
  } catch (e) {}
  function saveFilters() { try { sessionStorage.setItem(FILT, JSON.stringify({ g: activeGender, s: activeSeason, c: activeCat })); } catch (e) {} }

  /* cached once — cards are server-rendered and never added/removed (only
     toggled), so we avoid re-querying the DOM on every keystroke/filter */
  var searchEl = root.querySelector("[data-sp-search]");
  var noResEl = root.querySelector("[data-sp-noresults]");
  var allCards = root.querySelectorAll("[data-sp-card]");
  var seasonSel = root.querySelector("[data-sp-season]");
  var catSel = root.querySelector("[data-sp-cat]");
  var resetBtn = root.querySelector("[data-sp-reset]");
  var lmWrap = root.querySelector("[data-sp-loadmore]");
  var lbClose = null;   /* the gallery module publishes its close() here so a filter change can always dismiss a stale viewer */

  /* token match against a space-separated attribute ("mens-rtw" must never
     substring-match a "womens-rtw" token) */
  function hasTok(str, tok) { return (" " + (str || "") + " ").indexOf(" " + tok + " ") >= 0; }
  /* accent-insensitive search: "andre" must find "André" */
  function norm(s) {
    s = (s || "").toLowerCase();
    try { s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); } catch (e) {}
    return s;
  }

  /* Category display names for the option list (official tag spellings are
     the apostrophe forms; tokens are the normalized handles). Only categories
     that actually exist on rendered cards are offered. */
  var CAT_LABELS = {
    "womens-eveningwear": "Women's Eveningwear", "womens-rtw": "Women's RTW",
    "mens-suiting": "Men's Suiting", "mens-rtw": "Men's RTW"
  };
  var CAT_ORDER = { womens: ["womens-eveningwear", "womens-rtw"], mens: ["mens-suiting", "mens-rtw"],
    pullonly: ["womens-eveningwear", "womens-rtw", "mens-suiting", "mens-rtw"] };

  /* per-gender availability, computed once from the server-rendered cards */
  var catsByGender = { womens: {}, mens: {}, pullonly: {} }, seasonsByGender = { womens: {}, mens: {}, pullonly: {} };
  (function () {
    for (var i = 0; i < allCards.length; i++) {
      /* a For Pull Only card feeds only the exclusive tab's option lists */
      var c = allCards[i], g = c.dataset.pullonly === "1" ? "pullonly"
        : (c.dataset.gender === "mens" ? "mens" : "womens");
      (c.dataset.cats || "").split(" ").forEach(function (t) { if (t) catsByGender[g][t] = true; });
      (c.dataset.seasons || "").split(" ").forEach(function (t) { if (t) seasonsByGender[g][t] = true; });
    }
  })();
  /* full season option list as rendered by Liquid (value + label, newest first) */
  var SEASONS_ALL = [].slice.call(seasonSel ? seasonSel.querySelectorAll("option") : [], 1)
    .map(function (o) { return { v: o.value, label: o.textContent }; });

  /* Rebuild both dropdowns for the active gender tab: only offer collections/
     categories that have at least one card in this tab; keep the current
     selection when still offered, otherwise fall back to All. */
  function buildFilterOptions() {
    if (seasonSel) {
      seasonSel.innerHTML = '<option value="">All collections</option>' + SEASONS_ALL
        .filter(function (s) { return seasonsByGender[activeGender][s.v]; })
        .map(function (s) { return '<option value="' + esc(s.v) + '">' + esc(s.label) + "</option>"; }).join("");
      seasonSel.value = activeSeason;
      if (seasonSel.value !== activeSeason) { activeSeason = ""; seasonSel.value = ""; }
    }
    if (catSel) {
      catSel.innerHTML = '<option value="">All items</option>' + CAT_ORDER[activeGender]
        .filter(function (t) { return catsByGender[activeGender][t]; })
        .map(function (t) { return '<option value="' + t + '">' + esc(CAT_LABELS[t] || t) + "</option>"; }).join("");
      catSel.value = activeCat;
      if (catSel.value !== activeCat) { activeCat = ""; catSel.value = ""; }
    }
  }

  function applyFilters() {
    if (lbClose) lbClose();                        /* defensive: never leave an overlay/scroll-lock behind on a filter change */
    var q = norm((searchEl && searchEl.value) || "");
    var filtering = !!(q || activeSeason || activeCat);   /* any active filter reveals all matches (bypasses the 24-card collapse) */
    var any = false, pending = false, i;
    for (i = 0; i < allCards.length; i++) {
      var c = allCards[i];
      /* For Pull Only pieces appear only under their own tab, and the normal
         tabs never show them — the two catalogs stay visually distinct. */
      var isPO = c.dataset.pullonly === "1";
      var inTab = activeGender === "pullonly" ? isPO : (!isPO && c.dataset.gender === activeGender);
      var ok = inTab
        && (!q || norm(c.dataset.title).indexOf(q) >= 0 || norm(c.dataset.skus).indexOf(q) >= 0 || norm(c.dataset.type).indexOf(q) >= 0)
        && (!activeSeason || hasTok(c.dataset.seasons, activeSeason))
        && (!activeCat || hasTok(c.dataset.cats, activeCat));
      var collapsed = !filtering && c.hasAttribute("data-more") && !c.classList.contains("is-revealed");
      c.hidden = !ok || collapsed;
      any = any || !c.hidden;
      if (ok && collapsed) pending = true;
    }
    var note = root.querySelector("[data-sp-pullonly-note]");
    if (note) note.hidden = !(hasPullOnly && activeGender === "pullonly");
    if (lmWrap) lmWrap.parentElement.hidden = lmWrap.hidden = filtering || !pending;
    if (resetBtn) resetBtn.hidden = !filtering;
    if (noResEl) noResEl.hidden = any;
  }

  function paintGenderTabs() {
    root.querySelectorAll("[data-sp-gender]").forEach(function (b) {
      var on = b.dataset.spGender === activeGender;
      b.classList.toggle("is-active", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  root.addEventListener("click", function (e) {
    var tab = e.target.closest("[data-sp-gender]");
    if (!tab) return;
    /* Switch gender in place: no scrollIntoView, no hash change, no focus
       move — the header, heading, tabs, and filters stay put and the scroll
       position is preserved. The clicked <button> keeps focus (it isn't hidden),
       so nothing scrolls; capture + restore guards against any reflow. */
    var y = window.pageYOffset;
    var want = tab.dataset.spGender;
    activeGender = (want === "mens" || want === "pullonly") ? want : "womens";
    buildFilterOptions();          /* category/collection options follow the tab */
    saveFilters(); paintGenderTabs(); applyFilters();
    if (window.pageYOffset !== y) window.scrollTo(0, y);
  });
  if (seasonSel) seasonSel.addEventListener("change", function () {
    activeSeason = seasonSel.value || ""; saveFilters(); applyFilters();
  });
  if (catSel) catSel.addEventListener("change", function () {
    activeCat = catSel.value || ""; saveFilters(); applyFilters();
  });
  if (resetBtn) resetBtn.addEventListener("click", function () {
    activeSeason = ""; activeCat = "";
    if (searchEl) searchEl.value = "";
    if (seasonSel) seasonSel.value = "";
    if (catSel) catSel.value = "";
    saveFilters(); applyFilters();
    announce("Filters reset.");
  });
  var searchTimer = null;
  if (searchEl) searchEl.addEventListener("input", function () {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(applyFilters, 140);   /* debounce typing */
  });
  root.addEventListener("click", function (e) {
    var lm = e.target.closest("[data-sp-loadmore]");
    if (!lm) return;
    var pending = root.querySelectorAll("[data-sp-card][data-more]:not(.is-revealed)");
    var revealed = 0;
    for (var k = 0; k < pending.length && revealed < 24; k++) {
      var pc = pending[k], pIsPO = pc.dataset.pullonly === "1";
      if (activeGender === "pullonly" ? !pIsPO : (pIsPO || pc.dataset.gender !== activeGender)) continue;
      pending[k].classList.add("is-revealed"); revealed++;
    }
    applyFilters();
  });
  /* restore persisted filter UI, then paint the initial grid */
  buildFilterOptions();
  paintGenderTabs();
  applyFilters();

  /* Per-line quantity cap: the sample count for that size (never the retail
     stock), bounded by the portal-wide max. Sizes without a sample count yet
     ("availability on request") use the portal max. */
  function lineCap(sampleQty) {
    return Math.min(CFG.maxQty, sampleQty > 0 ? sampleQty : CFG.maxQty);
  }
  /* Availability wording is driven ONLY by the sample ledger: a counted size
     is "Sample available"; an uncounted size is offered on request. */
  function availLabel(sampleQty) {
    return sampleQty > 0 ? "Sample available" : "Sample availability on request";
  }
  /* Returns true (added), "capped" (line already holds every sample of that
     size), or false (invalid variant / list full). */
  function addItem(data, vid, qty, note) {
    var variant = data.variants.find(function (v) { return String(v.id) === String(vid); });
    if (!variant) return false;
    var cap = lineCap(variant.sampleQty);
    qty = Math.min(cap, Math.max(1, parseInt(qty || "1", 10)));
    note = (note || "").slice(0, 140);
    var list = pull();
    var existing = list.find(function (i) { return String(i.variantId) === String(vid); });
    if (existing) {
      var before = existing.qty;
      existing.qty = Math.min(cap, existing.qty + qty);
      if (note) existing.note = note;
      if (existing.qty === before) {
        savePull(list);
        announce("All available samples of this size are already in your pull list.");
        return "capped";
      }
    } else {
      if (list.length >= CFG.maxItems) { announce("Pull list is full (" + CFG.maxItems + " lines max)."); return false; }
      list.push({ variantId: variant.id, title: data.title, variantTitle: variant.title, sku: variant.sku || "",
        available: true, sampleQty: variant.sampleQty || 0, qty: qty, note: note,
        url: data.url, image: data.image, type: data.type });
    }
    savePull(list);
    announce("Added " + data.title + " (" + variant.title + ") to your pull list.");
    return true;
  }

  /* Brief visual confirmation on an Add button (text only — the button stays
     enabled so rapid clicks still land and simply clamp). */
  function flashAdd(btn, result) {
    if (!btn || btn.dataset.spFlashing) return;
    var original = btn.textContent;
    btn.dataset.spFlashing = "1";
    btn.textContent = result === true ? "Added ✓" : result === "capped" ? "Max samples in list" : "Could not add";
    if (result === true) btn.classList.add("is-added");
    setTimeout(function () {
      btn.textContent = original;
      btn.classList.remove("is-added");
      delete btn.dataset.spFlashing;
    }, 1200);
  }

  root.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-sp-add]");
    if (!btn) return;
    var card = btn.closest("[data-sp-card]");
    /* Grid cards add exactly one unit of the selected variant; repeated clicks
       merge into the existing pull line (addItem increments qty). No card-level
       quantity or note input — quantity is edited on the pull-list page. */
    flashAdd(btn, addItem(cardData(card), card.querySelector("[data-sp-variant]").value, 1, ""));
  });

  /* ---------- color swatches: pick a color, the size dropdown follows ----------
     Every option always maps to one exact Shopify variant id — colors and sizes
     are never merged. Swatch backgrounds: variant image when Shopify has one
     (accurate for prints), a curated color map otherwise, neutral if unknown. */
  function cardData(card) {
    if (!card._spd) card._spd = JSON.parse(card.querySelector("[data-sp-data]").textContent);
    return card._spd;
  }
  var SWATCH_COLORS = {
    "black": "#141414", "white": "#fdfdfd", "blue": "#2b4a9f", "light blue": "#8db6d9",
    "red": "#b3202a", "cherry red": "#b3122f", "pink": "#e8a0b4", "rose pink": "#dd8ba4",
    "dusty pink": "#c9989d", "fuchsia": "#c3459c", "yellow": "#e7c53a", "neon yellow": "#dbe94a",
    "orange": "#d97a2e", "burnt orange": "#b45a1e", "teal": "#2a7c7c", "deep teal": "#155e5e",
    "green": "#3d7a44", "kelly green": "#2e8b3d", "forest green": "#1e5631", "lime green": "#9acd32",
    "silver": "#c9c9c9", "gold": "#c9a24b", "true gold": "#c9a24b", "copper": "#b46b45",
    "denim": "#3b5f8a", "dark denim": "#2a4463", "light denim": "#7d9cbd", "brown": "#6b4e31"
  };
  function paintSwatch(btn) {
    if (btn.style.backgroundImage) return;              /* variant image wins */
    var name = (btn.dataset.spSwatch || "").toLowerCase();
    if (SWATCH_COLORS[name]) { btn.style.backgroundColor = SWATCH_COLORS[name]; return; }
    var duo = name.split(" & ");                        /* two-tone names: "Orange & Black" */
    if (duo.length === 2 && SWATCH_COLORS[duo[0]] && SWATCH_COLORS[duo[1]]) {
      btn.style.backgroundImage = "linear-gradient(45deg, " + SWATCH_COLORS[duo[0]] + " 50%, " + SWATCH_COLORS[duo[1]] + " 50%)";
      return;
    }                                                    /* unknown print: neutral + tooltip */
  }
  root.querySelectorAll("[data-sp-swatch]").forEach(paintSwatch);
  /* All images belonging to a color: matched by the color name appearing in the
     image filename or alt text (this catalog names files e.g. "...Kelly-Green...",
     "...Seersucker-Green..."), so the whole run of shots for a color travels
     together — not just the one image the variant happens to link. */
  var SP_COLORS = { black:1, white:1, red:1, green:1, blue:1, brown:1, pink:1, orange:1, yellow:1, gold:1, silver:1,
    teal:1, fuchsia:1, purple:1, gray:1, grey:1, beige:1, tan:1, navy:1, burgundy:1, olive:1, ivory:1, cream:1, khaki:1,
    rose:1, rosy:1, coral:1, lavender:1, lilac:1, mint:1, mustard:1, cherry:1, sapphire:1, emerald:1, magenta:1,
    maroon:1, crimson:1, scarlet:1, turquoise:1, aqua:1, peach:1, salmon:1, mauve:1, plum:1, wine:1, camel:1,
    espresso:1, mocha:1, sand:1, charcoal:1, sage:1, forest:1, lime:1, bronze:1 };
  function spTokens(s) { return (s || "").toLowerCase().split(/[^a-z0-9]+/).filter(Boolean); }
  /* Assign every product image to a swatch color. Score each image by how many of a
     color's DISTINCTIVE words (words not shared with another color of the same product)
     appear in its filename/alt, and give it to the top-scoring color. This keeps
     "Kelly Green" vs "Seersucker Green" apart (the shared word "green" is ignored) and
     still catches "Brown Cheetah Print" from files named only "Cheetah". A color that
     matches nothing (its name isn't written into any file, e.g. "Fuchsia") inherits the
     images no color claimed, so its full run of shots still travels together. */
  function spColorMap(data) {
    if (data._colorMap) return data._colorMap;
    var colors = [];
    (data.variants || []).forEach(function (v) { if (v.color && colors.indexOf(v.color) < 0) colors.push(v.color); });
    var ctoks = {}, count = {};
    colors.forEach(function (c) {
      var seen = {}; ctoks[c] = [];
      spTokens(c).forEach(function (t) { if (!seen[t]) { seen[t] = 1; ctoks[c].push(t); } });
      ctoks[c].forEach(function (t) { count[t] = (count[t] || 0) + 1; });
    });
    var distinct = {};
    colors.forEach(function (c) {
      var d = ctoks[c].filter(function (t) { return count[t] < 2; });
      distinct[c] = d.length ? d : ctoks[c];
    });
    var assigned = {}, unassigned = [];
    colors.forEach(function (c) { assigned[c] = []; });
    (data.images || []).forEach(function (im, i) {
      var itset = {}; spTokens((im.src || "") + " " + (im.alt || "")).forEach(function (t) { itset[t] = 1; });
      var best = 0, score = {};
      colors.forEach(function (c) {
        var s = 0; distinct[c].forEach(function (t) { if (itset[t]) s++; });
        score[c] = s; if (s > best) best = s;
      });
      if (best > 0) colors.forEach(function (c) { if (score[c] === best) assigned[c].push(i); });
      else unassigned.push(i);
    });
    colors.forEach(function (c) { if (!assigned[c].length && unassigned.length) assigned[c] = unassigned.slice(); });
    data._colorMap = assigned;
    return assigned;
  }
  function colorImageIdxs(data, color) { return (spColorMap(data)[color] || []).slice(); }
  function applySwatch(card, color) {
    var sel = card.querySelector("[data-sp-variant]");
    var keepSize = (sel.selectedOptions[0] || {}).textContent;
    var vs = cardData(card).variants.filter(function (v) { return (v.color || "") === color; });
    sel.innerHTML = vs.map(function (v) {
      return '<option value="' + v.id + '">' + esc(v.size || v.title) + "</option>";
    }).join("");
    var keep = [].find.call(sel.options, function (o) { return o.textContent === keepSize; });
    if (keep) sel.value = keep.value;
    card.querySelectorAll("[data-sp-swatch]").forEach(function (b) {
      var on = b.dataset.spSwatch === color;
      b.classList.toggle("is-selected", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
    var colorIdxs = colorImageIdxs(cardData(card), color);
    if (!colorIdxs.length) {
      /* no filename/alt match: fall back to the variants' linked images */
      vs.forEach(function (v) {
        if (v.imageIdx >= 0 && colorIdxs.indexOf(v.imageIdx) < 0) colorIdxs.push(v.imageIdx);
      });
      colorIdxs.sort(function (a, b) { return a - b; });
    }
    var gal = card.querySelector("[data-sp-gallery]");
    if (gal && root._spGalleryFilter) root._spGalleryFilter(gal, colorIdxs);
  }
  root.addEventListener("click", function (e) {
    var sw = e.target.closest("[data-sp-swatch]");
    if (!sw) return;
    applySwatch(sw.closest("[data-sp-card]"), sw.dataset.spSwatch);
  });

  /* ---------- product detail overlay ---------- */
  var ov = root.querySelector("[data-sp-overlay]");
  var ovData = null, ovReturnFocus = null;
  function ovVariantLine() {
    if (!ovData) return;
    var vid = ov.querySelector("[data-ov-variant]").value;
    var v = ovData.variants.find(function (x) { return String(x.id) === vid; });
    ov.querySelector("[data-ov-sku]").textContent = v
      ? (v.sku ? "SKU " + v.sku + " · " : "") + availLabel(v.sampleQty)
      : "";
    var qtyEl = ov.querySelector("[data-ov-qty]");
    if (v && qtyEl) {
      var cap = lineCap(v.sampleQty);
      qtyEl.max = cap;
      if (parseInt(qtyEl.value || "1", 10) > cap) qtyEl.value = cap;
    }
  }
  function openOverlay(card) {
    ovData = JSON.parse(card.querySelector("[data-sp-data]").textContent);
    ovReturnFocus = document.activeElement;
    var selVid = card.querySelector("[data-sp-variant]").value;
    var selVar = ovData.variants.find(function (v) { return String(v.id) === String(selVid); });
    var ovImg = ovData.image || "";
    if (selVar) {
      var grp = colorImageIdxs(ovData, selVar.color);
      if (grp.length && ovData.images[grp[0]]) ovImg = ovData.images[grp[0]].src;
      else if (selVar.imageIdx >= 0 && ovData.images && ovData.images[selVar.imageIdx]) ovImg = ovData.images[selVar.imageIdx].src;
    }
    ov.querySelector("[data-ov-img]").src = ovImg;
    ov.querySelector("[data-ov-img]").alt = ovData.title;
    ov.querySelector("[data-ov-collection]").textContent = ovData.collection || ovData.type || "";
    ov.querySelector("[data-ov-title]").textContent = ovData.title;
    var ovPrice = ov.querySelector("[data-ov-price]");
    if (ovPrice) ovPrice.textContent = ovData.price ? ovData.price + " · informational only" : "";
    ov.querySelector("[data-ov-desc]").textContent = ovData.description || "";
    var sel = ov.querySelector("[data-ov-variant]");
    sel.innerHTML = ovData.variants.map(function (v) {
      return '<option value="' + v.id + '">' + esc(v.title) + "</option>";
    }).join("");
    sel.value = card.querySelector("[data-sp-variant]").value;
    ov.querySelector("[data-ov-qty]").value = "1";
    ov.querySelector("[data-ov-note]").value = "";
    ov.querySelector("[data-ov-status]").textContent = "";
    /* mirror the card's add state: on-loan cards render no [data-sp-add] */
    var ovOnLoan = !card.querySelector("[data-sp-add]");
    var ovAdd = ov.querySelector("[data-ov-add]");
    ovAdd.disabled = ovOnLoan;
    ovAdd.textContent = ovOnLoan ? "On loan" : "Add to pull";
    ov.querySelector("[data-ov-qty]").disabled = ovOnLoan;
    ovVariantLine();
    /* size guide: the product's own size_chart page (PDP popup source),
       else the department guide; hide the button when neither is rendered */
    var sg = ov.querySelector("[data-ov-sizeguide]");
    if (sg) {
      var g = (card.dataset.gender || "").toLowerCase();
      var sgh = ovData.sizeChart || (g === "mens" ? "mens-size-guide" : "size-guide");
      if (!root.querySelector('[data-sg-page="' + sgh + '"]')) {
        sgh = g === "mens" ? "mens-size-guide" : "size-guide";
      }
      sg.dataset.page = sgh;
      sg.hidden = !root.querySelector('[data-sg-page="' + sgh + '"]');
    }
    ov.hidden = false;
    document.body.style.overflow = "hidden";
    /* scroll affordance: measurable only once the overlay is visible */
    var descEl = ov.querySelector("[data-ov-desc]");
    var descWrap = ov.querySelector("[data-ov-descwrap]");
    if (descEl && descWrap) {
      descEl.scrollTop = 0;
      requestAnimationFrame(function () {
        descWrap.classList.toggle("is-scrollable", descEl.scrollHeight > descEl.clientHeight + 2);
      });
    }
    ov.querySelector(".mxl-sp-overlay-panel").focus();
  }
  function closeOverlay() {
    ov.hidden = true; ovData = null;
    document.body.style.overflow = "";
    if (ovReturnFocus) ovReturnFocus.focus();
  }
  root.addEventListener("click", function (e) {
    var d = e.target.closest("[data-sp-details]");
    if (d) { openOverlay(d.closest("[data-sp-card]")); return; }
    if (e.target.closest("[data-sp-overlay-close]")) closeOverlay();
  });

  /* ---------- size guide modal (mirrors the PDP size-chart popup) ---------- */
  var sgModal = root.querySelector("[data-sp-sg]");
  function openSg(handle) {
    if (!sgModal || !handle) return;
    var found = false;
    sgModal.querySelectorAll("[data-sg-page]").forEach(function (el) {
      var on = el.dataset.sgPage === handle;
      el.hidden = !on;
      if (on) found = true;
    });
    if (!found) return;
    sgModal.hidden = false;
    var p = sgModal.querySelector(".mxl-sp-sgmodal-panel");
    p.scrollTop = 0;
    p.focus();
  }
  function closeSg() {
    if (!sgModal || sgModal.hidden) return;
    sgModal.hidden = true;
    if (ov && !ov.hidden) ov.querySelector(".mxl-sp-overlay-panel").focus();
  }
  root.addEventListener("click", function (e) {
    var b = e.target.closest("[data-ov-sizeguide]");
    if (b) { openSg(b.dataset.page || ""); return; }
    if (e.target.closest("[data-sp-sg-close]")) closeSg();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (sgModal && !sgModal.hidden) { closeSg(); return; }
    if (ov && !ov.hidden) closeOverlay();
  });
  ov.querySelector("[data-ov-variant]").addEventListener("change", ovVariantLine);
  (function () {
    var d = ov.querySelector("[data-ov-desc]"), w = ov.querySelector("[data-ov-descwrap]");
    if (d && w) d.addEventListener("scroll", function () {
      var atEnd = d.scrollTop + d.clientHeight >= d.scrollHeight - 4;
      w.classList.toggle("is-scrollable", !atEnd);
    });
  })();
  ov.querySelector("[data-ov-add]").addEventListener("click", function (e) {
    if (!ovData) return;
    var r = addItem(ovData, ov.querySelector("[data-ov-variant]").value,
      ov.querySelector("[data-ov-qty]").value, ov.querySelector("[data-ov-note]").value);
    flashAdd(e.currentTarget, r);
    ov.querySelector("[data-ov-status]").textContent =
      r === true ? "Added to your pull list."
      : r === "capped" ? "All available samples of this size are already in your pull list."
      : "Could not add this item.";
  });

  function announce(msg) {
    var n = root.querySelector("[data-sp-count]");
    if (n) { n.setAttribute("aria-label", msg); }
    if (els.status) els.status.textContent = "";
    var live = document.createElement("div");
    live.className = "mxl-sp-vh"; live.setAttribute("role", "status"); live.textContent = msg;
    root.appendChild(live); setTimeout(function () { live.remove(); }, 1500);
  }

  /* ---------- pull list render + edit ---------- */
  function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : String(s); return d.innerHTML; }
  function renderPull() {
    var list = pull();
    els.pullEmpty.hidden = list.length > 0;
    els.pullList.innerHTML = list.map(function (i, idx) {
      return '<li class="mxl-sp-pull-item" data-idx="' + idx + '">' +
        '<img src="' + esc(i.image) + '" alt="" width="72" height="90">' +
        '<div class="mxl-sp-pull-info"><strong>' + esc(i.title) + "</strong>" +
        "<span>" + esc(i.variantTitle) + (i.sku ? " · " + esc(i.sku) : "") + "</span>" +
        "<span>" + availLabel(i.sampleQty) + "</span>" +
        '<label class="mxl-sp-vh" for="PN-' + idx + '">Note</label>' +
        '<input id="PN-' + idx + '" data-sp-pnote type="text" maxlength="140" value="' + esc(i.note) + '" placeholder="Item note (optional)"></div>' +
        '<div class="mxl-sp-pull-ctrl"><label class="mxl-sp-vh" for="PQ-' + idx + '">Quantity</label>' +
        '<input id="PQ-' + idx + '" data-sp-pqty type="number" min="1" max="' + lineCap(i.sampleQty) + '" value="' + i.qty + '">' +
        '<button type="button" data-sp-premove class="mxl-sp-link">Remove</button></div></li>';
    }).join("");
  }
  els.pullList.addEventListener("input", function (e) {
    var li = e.target.closest("[data-idx]"); if (!li) return;
    var list = pull(); var i = list[+li.dataset.idx]; if (!i) return;
    if (e.target.matches("[data-sp-pqty]")) {
      i.qty = Math.min(lineCap(i.sampleQty), Math.max(1, parseInt(e.target.value || "1", 10)));
      /* snap the visible value back when typed out of range, so the field
         never shows a quantity that exceeds the samples on hand */
      if (e.target.value !== "" && parseInt(e.target.value, 10) !== i.qty) e.target.value = i.qty;
    }
    if (e.target.matches("[data-sp-pnote]")) i.note = e.target.value.slice(0, 140);
    savePull(list);
  });
  els.pullList.addEventListener("click", function (e) {
    if (!e.target.matches("[data-sp-premove]")) return;
    var li = e.target.closest("[data-idx]");
    var list = pull(); list.splice(+li.dataset.idx, 1); savePull(list); renderPull();
  });

  /* ---------- form: draft persistence + validation ---------- */
  var FDRAFT = "mxl_sp_form";
  function formData() {
    var d = {};
    new FormData(els.form).forEach(function (v, k) { d[k] = String(v).trim(); });
    d.method = (els.form.querySelector('[name="method"]:checked') || {}).value || "Shipping";
    d.agreement = els.form.querySelector("[data-sp-agree]").checked;
    return d;
  }
  function restoreForm() {
    try {
      var d = JSON.parse(sessionStorage.getItem(FDRAFT) || "null"); if (!d) return;
      Object.keys(d).forEach(function (k) {
        var el = els.form.querySelector('[name="' + k + '"]');
        if (!el) return;
        if (el.type === "radio") { var r = els.form.querySelector('[name="' + k + '"][value="' + d[k] + '"]'); if (r) r.checked = true; }
        else if (el.type === "checkbox") el.checked = !!d[k];
        else el.value = d[k];
      });
    } catch (e) {}
  }
  /* Confidential project type: hide the other PROJECT fields, drop their required
     state, and show the explanatory note. Values are preserved in the inputs, so
     switching back to another type restores them. Hidden fields use the [hidden]
     attribute (display:none) which also removes them from tab order and the a11y
     tree, so focus is never trapped and validation can't target them. */
  function toggleProject() {
    var sel = els.form.querySelector("[data-sp-ptype]");
    var confidential = !!sel && sel.value === "Confidential";
    els.form.querySelectorAll("[data-sp-project-field]").forEach(function (f) { f.hidden = confidential; });
    var note = els.form.querySelector("[data-sp-confidential-note]");
    if (note) note.hidden = !confidential;
    var proj = els.form.querySelector('[name="project"]');
    if (proj) { if (confidential) proj.removeAttribute("required"); else proj.setAttribute("required", ""); }
    if (confidential) { setErr("project", ""); setErr("moodboard", ""); }
  }
  els.form.addEventListener("input", function () {
    sessionStorage.setItem(FDRAFT, JSON.stringify(formData()));
    var ship = formData().method === "Shipping";
    root.querySelector("[data-sp-address-wrap]").style.display = ship ? "" : "none";
    toggleProject();
  });
  function setErr(name, msg) {
    var el = els.form.querySelector('[name="' + name + '"]');
    var err = el && el.closest(".mxl-sp-field") ? el.closest(".mxl-sp-field").querySelector(".mxl-sp-err") : null;
    if (err) err.textContent = msg || "";
    if (el) el.setAttribute("aria-invalid", msg ? "true" : "false");
    return !msg;
  }
  function validate() {
    var d = formData(), ok = true, today = new Date().toISOString().slice(0, 10);
    ok = setErr("stylist_name", d.stylist_name ? "" : "Please enter your name.") && ok;
    ok = setErr("company", d.company ? "" : "Please enter your company or production.") && ok;
    ok = setErr("email", /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(d.email) ? "" : "Please enter a valid email.") && ok;
    ok = setErr("phone", d.phone.replace(/[^0-9]/g, "").length >= 7 ? "" : "Please enter a valid phone number.") && ok;
    var confidential = d.project_type === "Confidential";
    ok = setErr("project_type", d.project_type ? "" : "Please select a project type.") && ok;
    if (confidential) { setErr("project", ""); setErr("moodboard", ""); }   /* hidden project fields never block submission */
    else {
      ok = setErr("project", d.project ? "" : "Please name the project.") && ok;
      ok = setErr("moodboard", !d.moodboard || /^https?:\/\/\S+$/.test(d.moodboard) ? "" : "Links must start with http or https.") && ok;
    }
    ok = setErr("delivery_date", d.delivery_date && d.delivery_date >= today ? "" : "Choose a delivery date from today onward.") && ok;
    ok = setErr("return_date", d.return_date && d.return_date >= (d.delivery_date || today) ? "" : "Return date must be on or after delivery.") && ok;
    if (d.method === "Shipping") ok = setErr("address", d.address ? "" : "Shipping requires an address.") && ok;
    else setErr("address", "");
    var agreeErr = els.form.querySelector(".mxl-sp-field--check .mxl-sp-err");
    agreeErr.textContent = d.agreement ? "" : "Please acknowledge the sample terms.";
    ok = ok && d.agreement;
    return ok;
  }
  els.form.addEventListener("submit", function (e) {
    e.preventDefault();
    if (!validate()) { var bad = els.form.querySelector('[aria-invalid="true"]'); if (bad) bad.focus(); return; }
    location.hash = "#review";
  });

  /* ---------- review ---------- */
  function renderReview() {
    var d = formData(), list = pull();
    var rows = list.map(function (i) {
      return "<tr><td>" + esc(i.title) + "</td><td>" + esc(i.variantTitle) + "</td><td>" + esc(i.sku) + "</td><td>" + i.qty + "</td><td>" + esc(i.note) + "</td></tr>";
    }).join("");
    els.review.innerHTML =
      "<h3>Contact</h3><p>" + esc(d.stylist_name) + " · " + esc(d.company) + "<br>" + esc(d.email) + " · " + esc(d.phone) +
      (d.secondary_contact ? "<br>Secondary: " + esc(d.secondary_contact) : "") + "</p>" +
      "<h3>Project</h3><p>" + (d.project_type === "Confidential"
        ? "Type: Confidential<br><em>Additional project details withheld.</em>"
        : esc(d.project) + (d.talent ? " · " + esc(d.talent) : "") + " · " + esc(d.project_type) +
          (d.usage ? "<br>Usage: " + esc(d.usage) : "") + (d.shoot_date ? "<br>Shoot: " + esc(d.shoot_date) : "")) + "</p>" +
      "<h3>Logistics</h3><p>Delivery " + esc(d.delivery_date) + " · Return " + esc(d.return_date) + " · " + esc(d.method) +
      (d.method === "Shipping" ? "<br>" + esc(d.address) : "") + "</p>" +
      (d.notes ? "<h3>Notes</h3><p>" + esc(d.notes) + "</p>" : "") +
      "<h3>Items (" + list.reduce(function (a, i) { return a + i.qty; }, 0) + ")</h3>" +
      '<table class="mxl-sp-table"><thead><tr><th>Style</th><th>Variant</th><th>SKU</th><th>Qty</th><th>Note</th></tr></thead><tbody>' + rows + "</tbody></table>";
  }

  /* ---------- submit ---------- */
  var submitting = false;
  root.querySelector("[data-sp-submit]").addEventListener("click", function () {
    if (submitting) return;
    var d = formData(), list = pull();
    var confidential = d.project_type === "Confidential";
    if (confidential) { d.project = ""; d.talent = ""; d.usage = ""; d.shoot_date = ""; d.moodboard = ""; }   /* never send stale project details on a confidential request */
    if (!list.length) { location.hash = "#pull"; return; }
    if (!validate()) { location.hash = "#form"; return; }
    submitting = true;
    var btn = root.querySelector("[data-sp-submit]");
    btn.disabled = true; els.status.textContent = "Submitting your request…";
    var reference = "MXL-P-" + (function () { var A = "23456789BCDFGHJKMNPQRSTVWXYZ", s = ""; for (var i = 0; i < 4; i++) s += A.charAt(Math.floor(Math.random() * A.length)); return s; })();
    var payload = {
      data: { type: "event", attributes: {
        unique_id: reference,
        metric: { data: { type: "metric", attributes: { name: "Stylist Pull Request" } } },
        profile: { data: { type: "profile", attributes: { email: d.email } } },
        properties: {
          reference: reference, source: "MxL Stylist Pull portal",
          stylist_name: d.stylist_name, company: d.company, email: d.email, phone: d.phone,
          secondary_contact: d.secondary_contact, project: d.project, talent: d.talent,
          project_type: d.project_type, project_confidential: confidential, usage: d.usage, shoot_date: d.shoot_date,
          delivery_date: d.delivery_date, return_date: d.return_date, method: d.method,
          address: d.method === "Shipping" ? d.address : "", responsible_party: d.responsible_party,
          handling: d.handling, notes: d.notes, moodboard: d.moodboard,
          item_count: list.reduce(function (a, i) { return a + i.qty; }, 0),
          line_count: list.length,
          items_text: list.map(function (i) { return "- " + i.title + " | " + i.variantTitle +
            (i.sku ? " | SKU " + i.sku : "") + " | qty " + i.qty +
            " | " + availLabel(i.sampleQty) + (i.sampleQty > 0 ? " (" + i.sampleQty + " at request time)" : "") +
            (i.note ? " | Note: " + i.note : "") + " | " + i.url; }).join("\n"),
          items: list.map(function (i) { return { title: i.title, variant: i.variantTitle, variant_id: i.variantId,
            sku: i.sku, qty: i.qty, note: i.note, availability: availLabel(i.sampleQty),
            sample_qty_at_request: i.sampleQty || 0,
            url: i.url, image: i.image }; })
        }
      } }
    };
    /* Customer receipt: a SEPARATE metric ("Stylist Pull Request Submitted")
       with its own structured payload, so the requester's confirmation email
       never renders from the internal alert's data and vice versa. unique_id
       is the reference + "-receipt", so replays/backfills can never produce a
       second receipt. Its success/failure is reported inside the operational
       event (receipt_queued) so the dashboard can show delivery status and
       offer a resend — the public success state never waits on it. */
    function receiptPayload() {
      return { data: { type: "event", attributes: {
        unique_id: reference + "-receipt",
        metric: { data: { type: "metric", attributes: { name: "Stylist Pull Request Submitted" } } },
        profile: { data: { type: "profile", attributes: { email: d.email } } },
        properties: {
          portal_type: "pull",
          request_reference: reference,
          requester_name: d.stylist_name,
          requester_email: d.email,
          company: d.company,
          project: confidential ? "" : d.project,
          project_type: d.project_type,
          project_confidential: confidential,
          requested_pickup_date: d.delivery_date,
          requested_return_date: d.return_date,
          delivery_method: d.method,
          notes: d.notes,
          submitted_at: new Date().toISOString(),
          /* Preformatted for the confirmation email. Klaviyo skips a whole send
             with "Email Syntax Error" if the template uses a filter it rejects,
             so every display string is built here and the template just prints. */
          submitted_at_label: nyStamp(),
          item_count: list.reduce(function (a, i) { return a + i.qty; }, 0),
          line_count: list.length,
          items: list.map(function (i) {
            var parts = String(i.variantTitle || "").split(" / ");
            var SZ = /^(XXS|XS|S|M|L|XL|XXL|One Size|S\/M|M\/L|\d+)$/;
            var size = parts.filter(function (p) { return SZ.test(p.trim()); })[0] || i.variantTitle;
            var color = parts.filter(function (p) { return !SZ.test(p.trim()); }).join(" / ");
            return { product_title: i.title, product_handle: (i.url || "").split("/products/")[1] || "",
                     variant_id: i.variantId, variant_title: i.variantTitle,
                     color: color, size: size, quantity: i.qty, sku: i.sku || "",
                     image_url: i.image, product_url: i.url,
                     sample_quantity_at_request: i.sampleQty || 0, note: i.note || "" };
          })
        } } } };
    }
    var receiptQueued = false;
    fetch("https://a.klaviyo.com/client/events/?company_id=" + encodeURIComponent(CFG.company), {
      method: "POST",
      headers: { "Content-Type": "application/json", revision: "2025-04-15" },
      body: JSON.stringify(receiptPayload())
    }).then(function (rr) { receiptQueued = rr.ok; }).catch(function () { receiptQueued = false; })
      .then(function () {
        payload.data.attributes.properties.receipt_queued = receiptQueued;
        payload.data.attributes.properties.receipt_email = d.email;
        return fetch("https://a.klaviyo.com/client/events/?company_id=" + encodeURIComponent(CFG.company), {
          method: "POST",
          headers: { "Content-Type": "application/json", revision: "2025-04-15" },
          body: JSON.stringify(payload)
        });
      }).then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      els.ref.textContent = reference;
      els.time.textContent = new Date().toLocaleString();
      els.doneSummary.innerHTML = "<ul>" + list.map(function (i) {
        return "<li>" + esc(i.title) + " · " + esc(i.variantTitle) + " · qty " + i.qty + "</li>";
      }).join("") + "</ul>";
      localStorage.removeItem("mxl_sp_pull");
      sessionStorage.removeItem(FDRAFT);
      refreshCount();
      els.status.textContent = "";
      submitting = false; btn.disabled = false;
      location.hash = "#done";
    }).catch(function () {
      submitting = false; btn.disabled = false;
      els.status.textContent = "Something went wrong. Please check your connection and submit again. Your list is saved.";
    });
  });
  root.querySelector("[data-sp-newrequest]").addEventListener("click", function () { els.form.reset(); });

  /* ---------- product image gallery + lightbox ---------- */
  (function () {
    /* Card galleries swap a single <img> src (light on a 480-card grid). Full
       media array + hi-res zoom URLs live in each card's [data-sp-data] JSON.
       Card arrows are pointer/touch affordances (tabindex -1); the keyboard-
       accessible path to view every image is the enlarge button -> lightbox,
       which has focusable prev/next/close and arrow-key + Escape support. */
    function imagesOfAll(gal) {
      if (gal._all) return gal._all;
      var card = gal.closest("[data-sp-card]"), imgs = [];
      try { imgs = (JSON.parse(card.querySelector("[data-sp-data]").textContent).images) || []; } catch (e) {}
      gal._all = imgs; return imgs;
    }
    /* imagesOf returns the ACTIVE view (a color filter narrows it); default = all */
    function imagesOf(gal) { return gal._imgs || imagesOfAll(gal); }
    function syncControls(gal) {
      var n = imagesOf(gal).length;
      var prev = gal.querySelector("[data-sp-gprev]"), next = gal.querySelector("[data-sp-gnext]"),
          dots = gal.querySelector("[data-sp-dots]"), zoom = gal.querySelector("[data-sp-zoom]");
      if (prev) prev.hidden = n <= 1;
      if (next) next.hidden = n <= 1;
      if (dots) {
        if (n > 1) { dots.innerHTML = ""; buildDots(dots, n, "mxl-sp-dot"); dots.hidden = false; }
        else { dots.innerHTML = ""; dots.hidden = true; }
      }
      if (zoom) zoom.hidden = n < 1;
    }
    function buildDots(container, n, cls) {
      if (container.childElementCount === n) return;
      container.innerHTML = "";
      for (var i = 0; i < n; i++) {
        var b = document.createElement("button");
        b.type = "button"; b.className = cls; b.dataset.dot = i; b.tabIndex = -1;
        b.setAttribute("aria-label", "Go to image " + (i + 1));
        container.appendChild(b);
      }
    }
    function markDots(container, idx) {
      [].forEach.call(container.children, function (c, i) { c.classList.toggle("is-on", i === idx); });
    }
    function render(gal, idx) {
      var imgs = imagesOf(gal), n = imgs.length;
      if (n < 1) return;
      idx = (idx % n + n) % n;                 /* gallery loops */
      gal.dataset.spIdx = idx;
      var img = gal.querySelector("[data-sp-gallery-img]");
      if (img && imgs[idx]) {
        /* The Liquid-rendered srcset lists only the featured image at 400/600/800w,
           so the browser would keep rendering it and ignore any new src. Drop
           srcset/sizes and drive the single <img> by src (900w — ample for the
           card at retina). object-fit:cover in the fixed 4/5 box = no layout shift. */
        img.removeAttribute("srcset");
        img.removeAttribute("sizes");
        img.src = imgs[idx].src;
        if (imgs[idx].alt) img.alt = imgs[idx].alt;
      }
      var dots = gal.querySelector("[data-sp-dots]");
      if (dots && n > 1) markDots(dots, idx);
    }
    function initGallery(gal) {
      if (gal._init) return; gal._init = true;
      var n = parseInt(gal.dataset.spImgCount || "0", 10);
      gal.dataset.spIdx = "0";
      var prev = gal.querySelector("[data-sp-gprev]"), next = gal.querySelector("[data-sp-gnext]"),
          zoom = gal.querySelector("[data-sp-zoom]"), dots = gal.querySelector("[data-sp-dots]");
      if (n > 1) {
        if (prev) prev.hidden = false;
        if (next) next.hidden = false;
        if (dots) { buildDots(dots, n, "mxl-sp-dot"); markDots(dots, 0); dots.hidden = false; }
      }
      if (n >= 1 && zoom) zoom.hidden = false;
    }

    /* horizontal swipe helper: navigates on a clear horizontal drag, leaves
       vertical scrolling alone, and swallows the tap-click that follows a swipe
       so it can't trigger Add to Pull or open the viewer. */
    function attachSwipe(el, onSwipe) {
      var x0 = null, y0 = null, moved = false;
      el.addEventListener("touchstart", function (e) {
        if (e.touches.length !== 1) { x0 = null; return; }
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; moved = false;
      }, { passive: true });
      el.addEventListener("touchmove", function (e) {
        if (x0 == null) return;
        var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) { moved = true; if (e.cancelable) e.preventDefault(); }
      }, { passive: false });
      el.addEventListener("touchend", function (e) {
        if (x0 == null) return;
        var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) onSwipe(dx < 0 ? 1 : -1);
        x0 = null;
      }, { passive: false });
      el.addEventListener("click", function (e) { if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; } }, true);
    }

    /* lightbox (built once) */
    var lb = null, lbImgs = [], lbIdx = 0, lbReturn = null, lbGal = null, lbScrollY = 0;
    /* derive the large lightbox source from the card's 600w src — no separate
       zoom URL is embedded per image (saves ~40% of the card JSON) */
    function zoomUrl(src) { return src ? src.replace(/([?&]width=)\d+/, "$11600") : src; }
    function releaseLock() { document.body.classList.remove("mxl-sp-lb-open"); document.body.style.top = ""; }
    function buildLightbox() {
      lb = document.createElement("div");
      lb.className = "mxl-sp-lightbox"; lb.hidden = true;
      lb.setAttribute("role", "dialog"); lb.setAttribute("aria-modal", "true");
      lb.setAttribute("aria-label", "Product image viewer");
      lb.innerHTML =
        '<div class="mxl-sp-lb-bg"></div>' +
        '<div class="mxl-sp-lb-stage">' +
          '<img class="mxl-sp-lb-img" data-lb-img alt="">' +
          '<button type="button" class="mxl-sp-lb-nav mxl-sp-lb-prev" data-lb-prev aria-label="Previous image">&#8249;</button>' +
          '<button type="button" class="mxl-sp-lb-nav mxl-sp-lb-next" data-lb-next aria-label="Next image">&#8250;</button>' +
          '<button type="button" class="mxl-sp-lb-x" data-lb-x aria-label="Close image viewer">&#215;</button>' +
          '<div class="mxl-sp-lb-dots" data-lb-dots aria-hidden="true"></div>' +
        '</div>';
      root.appendChild(lb);
      lb.addEventListener("click", function (e) {
        if (e.target.closest("[data-lb-prev]")) return lbGo(-1);
        if (e.target.closest("[data-lb-next]")) return lbGo(1);
        var d = e.target.closest("[data-lb-dot]"); if (d) return lbShow(+d.dataset.dot);
        if (e.target.closest("[data-lb-x]")) return closeLightbox();
        if (e.target.closest("[data-lb-img]")) return;   /* clicking the image never closes */
        closeLightbox();                                 /* backdrop or any empty stage area closes */
      });
      attachSwipe(lb.querySelector(".mxl-sp-lb-stage"), function (dir) { lbGo(dir); });
    }
    function lbShow(i) {
      var n = lbImgs.length; if (!n || !lb) return;
      lbIdx = (i % n + n) % n;
      var im = lbImgs[lbIdx], img = lb.querySelector("[data-lb-img]");
      img.src = zoomUrl(im.src); img.alt = im.alt || "";
      lb.querySelector("[data-lb-prev]").hidden = lb.querySelector("[data-lb-next]").hidden = n <= 1;
      var dots = lb.querySelector("[data-lb-dots]");
      if (n <= 1) { dots.hidden = true; }
      else { buildDots(dots, n, "mxl-sp-lb-dot"); markDots(dots, lbIdx); dots.hidden = false; }
    }
    function lbGo(dir) { lbShow(lbIdx + dir); }
    function openLightbox(imgs, startIdx, gal) {
      if (!imgs || !imgs.length) return;
      if (!lb) buildLightbox();
      if (!lb.hidden) closeLightbox();          /* single instance: never stack an already-open viewer */
      lbImgs = imgs; lbGal = gal || null; lbReturn = document.activeElement;
      lbScrollY = window.scrollY || window.pageYOffset || 0;
      lbShow(startIdx || 0);
      lb.hidden = false;
      document.body.classList.add("mxl-sp-lb-open");
      document.body.style.top = (-lbScrollY) + "px";
      lb.querySelector("[data-lb-x]").focus();
    }
    /* Defensive teardown: runs its cleanup even if called when already hidden, so
       the body scroll-lock can never be stranded (page can't stay frozen), and
       render/focus are guarded so an exception can never skip the lock release. */
    function closeLightbox() {
      if (!lb) return;
      var wasOpen = !lb.hidden;
      lb.hidden = true;
      releaseLock();
      if (wasOpen) {
        window.scrollTo(0, lbScrollY);
        if (lbGal) { try { render(lbGal, lbIdx); } catch (e) {} }
      }
      if (lbReturn && lbReturn.focus) { try { lbReturn.focus({ preventScroll: true }); } catch (e) {} }
      lbReturn = null;
    }
    lbClose = closeLightbox;   /* publish so a filter/category/search change dismisses any stale viewer */
    document.addEventListener("keydown", function (e) {
      if (!lb || lb.hidden) return;
      if (e.key === "Escape") { e.preventDefault(); closeLightbox(); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); lbGo(-1); }
      else if (e.key === "ArrowRight") { e.preventDefault(); lbGo(1); }
    });

    /* init + delegated interactions */
    /* card image follows the selected color swatch: narrow the gallery to just
       that color's image(s); an empty/unknown set restores the full gallery */
    root._spGalleryFilter = function (gal, indices) {
      initGallery(gal);
      var all = imagesOfAll(gal), imgs = null;
      if (indices && indices.length) {
        imgs = indices.map(function (i) { return all[i]; }).filter(Boolean);
      }
      gal._imgs = (imgs && imgs.length) ? imgs : all;
      syncControls(gal);
      render(gal, 0);
    };
    root.querySelectorAll("[data-sp-gallery]").forEach(function (gal) {
      initGallery(gal);
      attachSwipe(gal, function (dir) { render(gal, parseInt(gal.dataset.spIdx || "0", 10) + dir); });
      /* When only ONE color is available to pull, the product may still carry other
         colorways' photos (Shopify keeps them all on the product), so the card would
         show shades you can't pull (Trinity is pull-only in Cherry Red but has green +
         black coats; Luca in Rose Pink also has a Dusty Rose set). These files are named
         <product>-<colour>-<season>-…; take the colour segment (the tokens before the
         SS/FW season code, minus the product-name prefix common to every image, kept
         only if they are colour words), and when the product was shot in 2+ colourways,
         keep the images sharing the available variant's colour plus any colour-word-less
         detail shots. Colour-word gate + season position avoids splitting on
         "close up"/"full shot"/garment words. */
      try {
        var card = gal.closest("[data-sp-card]");
        var data = JSON.parse(card.querySelector("[data-sp-data]").textContent);
        var colors = [];
        (data.variants || []).forEach(function (v) { if (v.color && colors.indexOf(v.color) < 0) colors.push(v.color); });
        var imgs = data.images || [];
        if (colors.length === 1 && imgs.length > 1) {
          var pres = imgs.map(function (im) {
            var toks = spTokens((im.src || "").split("/").pop().split("?")[0].replace(/\.[a-z0-9]+$/i, ""));
            var si = -1;
            for (var i = 0; i < toks.length; i++) { if (/^(ss|fw)\d{2}$/.test(toks[i])) { si = i; break; } }
            return si < 0 ? null : toks.slice(0, si);
          });
          if (pres.filter(function (p) { return p; }).length >= 2) {
            var common = null;
            pres.forEach(function (p) {
              if (!p) return; var set = {}; p.forEach(function (t) { set[t] = 1; });
              if (common === null) common = set; else { var nc = {}; for (var t in common) { if (set[t]) nc[t] = 1; } common = nc; }
            });
            var sigs = pres.map(function (p) {
              return p ? p.filter(function (t) { return !common[t] && SP_COLORS[t]; }) : [];
            });
            var distinct = {};
            sigs.forEach(function (s) { if (s.length) distinct[s.slice().sort().join(",")] = 1; });
            if (Object.keys(distinct).length >= 2) {
              var anchor = null;
              (data.variants || []).forEach(function (v) { if (anchor === null && v.imageIdx >= 0) anchor = v.imageIdx; });
              var asig = (anchor !== null && sigs[anchor] && sigs[anchor].length)
                ? sigs[anchor] : spTokens(colors[0]).filter(function (t) { return SP_COLORS[t]; });
              var aset = {}; asig.forEach(function (t) { aset[t] = 1; });
              var keep = [];
              sigs.forEach(function (s, i) {
                if (!s.length || s.some(function (t) { return aset[t]; })) keep.push(i);
              });
              if (keep.length && keep.length < imgs.length) root._spGalleryFilter(gal, keep);
            }
          }
        }
      } catch (e) {}
    });
    root.addEventListener("click", function (e) {
      var gal = e.target.closest("[data-sp-gallery]"); if (!gal) return;
      if (e.target.closest("[data-sp-gprev]")) { e.preventDefault(); render(gal, parseInt(gal.dataset.spIdx || "0", 10) - 1); return; }
      if (e.target.closest("[data-sp-gnext]")) { e.preventDefault(); render(gal, parseInt(gal.dataset.spIdx || "0", 10) + 1); return; }
      var dot = e.target.closest("[data-sp-dots] [data-dot]"); if (dot) { e.preventDefault(); render(gal, +dot.dataset.dot); return; }
      if (e.target.closest("[data-sp-zoom]") || e.target.closest("[data-sp-gallery-img]")) {
        e.preventDefault(); openLightbox(imagesOf(gal), parseInt(gal.dataset.spIdx || "0", 10), gal);
      }
    });
  })();

  /* ---------- boot ---------- */
  var booted = false;
  restoreForm();
  toggleProject();   /* match the hidden/shown project fields to the restored project type */
  refreshCount();
  root.querySelector("[data-sp-address-wrap]").style.display = "";
  route();
  if (location.hash === "#mxl-sp-appointments") {
    var apPanel = document.getElementById("mxl-sp-appointments");
    if (apPanel) {
      var apRev = apPanel.querySelector(".mxl-sp-appt-reveal");
      if (apRev) apRev.open = true;
      apPanel.scrollIntoView();
    }
  }
  booted = true;
})();
